<div class="container-fluid p-0">
  <app-admin-header
    [header]="header"
    [links]="links"
    [breadcrumbs]="breadcrumbs"
    [stats]="stats"
  ></app-admin-header>
  <div class="container-fluid p-0 v4-bg-img">
    <div class="container-fluid p-0 py-4 cont-v4">
      <!-- skelition   -->
      <app-skelitions
        [hidden]="!skelition"
        [value]="7"
        class="mb-2"
      ></app-skelitions>
      <!-- skelition  END -->
      <div [hidden]="skelition" class="row mob-mx-3">
        <div class="col-md-4 col-12 my-2 poss-rel mob-p-0">
          <span class="circle-numer">
            <span
              *ngFor="let i of pages"
              class="circle-num-ui"
              [ngClass]="currentPage == changeToNumber(i) ? 'active' : ''"
              (click)="currentPage = changeToNumber(i); changePage(currentPage)"
              >{{ i }}</span
            >
          </span>

          <div class="card border-none card-mobile-alignment v4-bg">
            <div class="d-flex justify-content-between align-items-center mx-3">
              <span class="custom-pagination-text">
                {{ "comment result" | translator }}

                <br />{{ currentPage }} -
                {{ first + rows > totalRecords ? totalRecords : first + rows }}
                {{ "from" | translator }} {{ totalRecords }}</span
              >
              <div class="d-flex">
                <span class="custom-pagination" (click)="moveToLast(true)"
                  ><i class="pi pi-fw pi-angle-double-right icon-x2"></i
                ></span>
                <span
                  class="custom-pagination"
                  (click)="changePage(currentPage - 1)"
                  ><i class="pi pi-fw pi-angle-right icon-x2"></i
                ></span>
                <span
                  class="custom-pagination"
                  (click)="changePage(currentPage + 1)"
                  ><i class="pi pi-fw pi-angle-left icon-x2"></i
                ></span>
                <span class="custom-pagination" (click)="moveToLast(false)"
                  ><i class="pi pi-fw pi-angle-double-left icon-x2"></i
                ></span>
              </div>
            </div>

            <div class="d-flex p-3">
              <span class="p-float-label w-100">
                <input
                  type="text"
                  id="float-label"
                  class="w-100"
                  (keyup)="applyFilterGlobal($event, 'contains')"
                  pInputText
                  placeholder="{{ 'Search for a name or number' | translator }}"
                />
                <label for="float-label">{{ "Discus" | translator }}</label>
              </span>
            </div>

            <p-dataView
              #dv
              [value]="filteredData"
              filterBy="_id.name,_id.id,comments[0].text"
              [rows]="10"
              [paginator]="true"
              [sortField]="sortField"
              [sortOrder]="sortOrder"
              (onPage)="onPageChange($event)"
              paginatorPosition="none"
              emptyMessage="{{ 'There is no data' | translator }}"
            >
              <ng-template let-item let-index="rowIndex" pTemplate="listItem">
                <div
                  class="list-item custom-w-90 d-flex flex-row flex-nowrap flex-wrap align-items-center"
                  [ngClass]="
                    currentComment._id._id == item._id._id ? 'active' : ''
                  "
                  (click)="changeView(item)"
                >
                  <p-button
                    [label]="index + 1"
                    styleClass="p-button-outline p-button-sm p-button-text indexnum m-2"
                  ></p-button>

                  <div>
                    <p class="mb-0">{{ item._id.id }}</p>
                    <p>
                      <b>{{ item._id.name }}</b>
                    </p>
                  </div>
                </div>
              </ng-template>
            </p-dataView>
          </div>
        </div>
        <div class="col-md-8 col-12 my-2 v4-bg">
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-6">
              <label class="my-2">
                <h4>
                  <b>
                    {{ "Log filter" | translator }}
                  </b>
                </h4>
              </label>
              <div class="d-flex">
                <div class="d-flex">
                  <p class="m-2">
                    <b>
                      {{ "the condition" | translator }}
                    </b>
                  </p>
                  <p-selectButton
                    class="v4-active"
                    [options]="statusOptions"
                    (click)="handleStatusChange()"
                    [(ngModel)]="currentStatus"
                    optionLabel="arabic"
                    optionValue="name"
                  ></p-selectButton>
                </div>
              </div>
            </div>
          </div>

          <app-no-data
            *ngIf="!currentComment || currentComment.comments?.length == 0"
          ></app-no-data>
          <p-messages [(value)]="messages" [enableService]="false"></p-messages>

          <span
            *ngIf="
              currentComment?.comments && currentComment.comments.length > 0
            "
          >
            <div *ngFor="let comment of currentComment.comments">
              <div class="row my-2 d-flex align-items-center">
                <div class="col-lg-12 p-3">
                  <h5 class="card-title float-right" style="font-size: 1.75rem">
                    {{ currentComment._id.name }}
                  </h5>
                </div>

                <!-- <div class="col-lg-4 p-3 d-flex justify-content-end">
                              <div class="d-flex">
                                  <span class="btn-flex">
                                    <img *ngIf="checkisImg(comment.ou.image_sq); else elseBlock" src="{{staticURL}}{{comment.ou.image_sq}}"
                                    class="img-fluid p-1" style="max-height: 50px; max-width: 100px;">
                                  <ng-template #elseBlock>
                                    <i class="{{comment.ou.image_sq}} p-2" style="font-size: 1rem;"></i>
                                  </ng-template>
                                  </span>
                              </div>
                          </div> -->
              </div>
              <div class="card mt-3 border-nonee v4-card-7 mb-3">
                <div class="card-body">
                  <h5 class="card-title mb-4" style="font-size: 1rem">
                    {{ comment.text }}
                  </h5>
                  <h6 class="card-subtitle mb-2" style="font-size: 0.8rem">
                    {{
                      comment.createdAt | date : "EEEE, MMMM d, y, h:mm:ss a"
                    }}
                  </h6>
                  <h6 class="card-subtitle mb-2" style="font-size: 0.8rem">
                    {{ comment.by.name.first }} {{ comment.by.name.middle }}
                    {{ comment.by.name.last }}
                  </h6>
                  <h6 class="card-subtitle mb-3" style="font-size: 0.8rem">
                    {{ comment.by.email }}
                  </h6>

                  <div
                    [hidden]="comment.status == 'PENDING'"
                    *ngIf="comment.rejectReason && comment.rejectReason != ''"
                    class="border-box inner-box mt-2 p-3 border-nonee v4-card-7"
                  >
                    <h4 class="" style="font-size: 1rem; font-weight: 700">
                      {{ "Reply" | translator }}
                    </h4>
                    <p>
                      {{ comment.rejectReason }}
                    </p>
                  </div>

                  <div
                    [hidden]="comment.status != 'PENDING'"
                    class="form-outline mt-3 mb-4"
                  >
                    <textarea
                      class="form-control v4-bg v4-border"
                      [(ngModel)]="comment.rejectReason"
                      placeholder="{{ 'comment' | translator }}"
                      id="textAreaExample6"
                      rows="3"
                    ></textarea>
                  </div>

                  <div class="row">
                    <div
                      *ngIf="comment.status == 'PENDING' && hasPermission()"
                      class="col d-flex justify-content-start"
                    >
                      <button
                        (click)="openRejectModal(comment, 'APPROVED')"
                        class="comment-btn mx-2"
                      >
                        <i class="fa fa-check mx-2"></i
                        >{{ "Acceptance" | translator }}
                      </button>
                      <button
                        (click)="openRejectModal(comment, 'REJECTED')"
                        class="comment-btn mx-2"
                      >
                        <i class="fa fa-times mx-2"></i
                        >{{ "to reject" | translator }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Confirm Modal -->
<p-confirmDialog #cd [style]="{ width: '50vw' }">
  <ng-template pTemplate="footer">
    <button
      type="button"
      pButton
      icon="pi pi-check"
      label="{{ 'OK' | translator }}"
      (click)="cd.accept()"
    ></button>
    <button
      type="button"
      pButton
      icon="pi pi-times"
      label="{{ 'cancellation' | translator }}"
      (click)="cd.reject()"
    ></button>
      </ng-template
  >
</p-confirmDialog>

<app-footer></app-footer>
